<template>
  <v-card>
    <v-card-title>{{ $t('contacts.form.add.title')}}</v-card-title>
    <v-form ref="form" @submit.prevent="create">
    <v-card-text>
    
    <v-text-field required v-model="name" :label="$t('common.name')" prepend-icon="$name" :rules="[rules.required]" />
    <label>{{$t('forms.create.selectTag')}}</label>
    <tag-selector v-model="tag" :domain="domain" :is-disabled="isDisabled" />
    </v-card-text>
    <v-card-actions>
      <v-btn @click="create" :loading="creating" color="success"><v-icon left>$add</v-icon>{{ $t('dialog.create')}}</v-btn>
      <v-btn exact :to="{ name: 'forms' }" text><v-icon left>$close</v-icon>{{ $t('dialog.cancel')}}</v-btn>
    </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>

import ParseRoute from '@/mixins/parse-route'
import TagSelector from '@/components/TagAutocomplete'
import {mapState} from 'vuex'

export default {
  name: 'AddForm',
  components: {TagSelector},
  mixins: [ParseRoute],
  data() {
    return {
      tag: this.$route.params.segment,
      name: null,
      creating: false,
      rules: {
        required: v=> !!v || this.$t('form.rules.required'),
      }
    }
  },
  computed: {
    ...mapState('domains', ['item']),
    ...mapState('forms', ['list'])
  },
  methods: {
    async create() {
      if(!this.$refs.form.validate() || !this.tag) {
        this.$store.dispatch('ui/notify', {error: true, text: this.$t('forms.create.error')})
        return;
      }
      this.creating = true;
      let form = await this.$store.dispatch('forms/create', { 
        name: this.name, 
        tag: this.tag, 
        domain: this.item
       });
      this.creating = false;
      this.$router.push({name: 'form', params: { form: form.id }}); 
    },
    isDisabled(id) {
      return this.list.map(f => f.tagID).includes(id);
    }
  }
}
</script>

<style>

</style>